import { useMutation } from "@tanstack/react-query";
import {
  type RelatedPartyDto,
  putPartiesRelationsPublicID,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useReplacePartyRelationMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({
        data,
        partyPublicID,
      }: {
        data: RelatedPartyDto;
        partyPublicID: string;
      }) => putPartiesRelationsPublicID(data, partyPublicID),
    ),
    onSuccess: () => {
      onSuccess?.();
    },
    onError,
  });
